import React, { useState } from "react";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import { getPartnerBankDocuments } from "../../../redux/viewPartnerDocuments/action";
import { connect } from "react-redux";
import Verified from "../../../images/Verified-Partner.png";
import notVerified from "../../../images/notVerified.jpeg";
import { useLocation } from "react-router-dom";
import { saveAccountNoDetails } from "../../../redux/FirmBankDetails/action";
import useSession from "../../CustomLogout/useSession";
import { Spin, message, notification } from "antd";
import UiButton from "../../Common/UiButton/UiButton";
const BankDetailsTabs = ({
  bankDetails,
  setShow,
  showDrawer,
  accessToken,
  state,
  getPartnerBankDocuments,
  saveAccountNoDetails,
  getAll,
}) => {
  const [hideImg, setHideImg] = useState(false);

  const [disable, setDisable] = useState(false);

  const location = useLocation();
  const id = location?.state?.partnerFirmId;

  const handleSessionExpired = useSession();

  function showfirmBank() {
    getPartnerBankDocuments({ accessToken: accessToken, firmId: id }).then(
      (res) => {
        showDrawer();
        setShow("Bank");
      }
    );
  }

  const handleBankTrigger = () => {
    setDisable(true);
    const accountNumberData = {
      bankAccountNumber: bankDetails?.bankAccountNumber,
      accountHolderName: bankDetails?.accountHolderName?.trim(),
      bankAccountType: {
        id: bankDetails?.bankAccountType?.id,
        name: bankDetails?.bankAccountType?.name,
      },
      bankCode: "",
      bankBranchName: bankDetails?.bankBranchName,

      bankNameDetails: {
        id: bankDetails?.bankNameDetails?.id,
        name: bankDetails?.bankNameDetails?.name?.trim(),
      },
      bankMICRCode: bankDetails?.bankMICRCode?.trim(),
      bankIFSCCode: bankDetails?.bankIFSCCode?.trim(),
      bankAddress: bankDetails?.bankAddress?.trim(),
      bankVerificationConsentFlag: true,
    };

    saveAccountNoDetails({
      values: accountNumberData,
      access_token: accessToken,
      partnerFirmId: id,
    }).then((res) => {
      if (res && res.status === 200) {
        message.success("Bank Account Verified Successfully");
        setDisable(false);
        getAll();
      }
      if (res?.data?.error || res.message) {
        const errorCode = res?.data?.error?.errorCode || res.errorCode;
        const errorMessage = res?.data?.error?.message || res.message;
        setDisable(false);

        if (errorCode === "403" && res?.data?.error?.logoutStatus) {
          handleSessionExpired();
        } else {
          setDisable(false);
          notification.error({
            description: errorMessage,
            duration: 5,
            placement: "top",
          });
        }
      } else {
        setDisable(false);
      }
    });
  };

  let imgIconShow = bankDetails?.bankDetailsVerifiedFlag;
  return (
    <div className="inner-Tab-sec-edit-pat">
      <Tab.Container id="left-tabs-example" defaultActiveKey="first">
        <Row>
          <Col sm={2} className="left-side-tabs branchScroll">
            <Nav variant="pills" className="flex-column">
              <Nav.Item>
                <Nav.Link eventKey="first">
                  <div className="tab-selet-test">
                    <h4>Bank Details</h4>
                  </div>
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col sm={10}>
            <Tab.Content>
              <Tab.Pane eventKey="first">
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="ineer-ed-text tabs-sec mob-sec-bk"
                  >
                    <Col md={3} className="">
                      <div className="text-content-ed">
                        <h5>Account Holder Name</h5>
                        <h2>{bankDetails?.accountHolderName}</h2>
                      </div>
                    </Col>
                    <Col md={3} className="">
                      <div className="text-content-ed">
                        <h5>Account Type</h5>
                        <h2>{bankDetails?.bankAccountType?.name}</h2>
                      </div>
                    </Col>
                    <Col md={3} className="">
                      <div className="text-content-ed">
                        <h5>Account Number</h5>
                        <h2>{bankDetails?.bankAccountNumber}</h2>
                      </div>
                    </Col>
                    <Col md={3} className="">
                      <div className="text-content-ed">
                        <h5>Bank Name</h5>
                        <h2>{bankDetails?.bankNameDetails?.name}</h2>
                      </div>
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="ineer-ed-text tabs-sec mob-sec-bk"
                  >
                    <Col md={3} className="">
                      <div className="text-content-ed">
                        <h5>Branch</h5>
                        <h2>{bankDetails?.bankBranchName}</h2>
                      </div>
                    </Col>
                    <Col md={3} className="">
                      <div className="text-content-ed">
                        <h5>Micr Code</h5>
                        <h2>
                          {bankDetails?.bankMICRCode
                            ? bankDetails?.bankMICRCode
                            : "------"}
                        </h2>
                      </div>
                    </Col>
                    <Col md={3} className="">
                      <div className="text-content-ed">
                        <h5>IFSC Code</h5>
                        <h2>{bankDetails?.bankIFSCCode}</h2>
                      </div>
                    </Col>
                    <Col md={3} className="">
                      <div className="text-content-ed">
                        <h5>Bank Address</h5>
                        <h2>
                          {bankDetails?.bankAddress
                            ? bankDetails?.bankAddress
                            : "------"}
                        </h2>
                      </div>
                    </Col>
                  </Col>
                </Row>

                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="ineer-ed-text tabs-sec mob-sec-bk"
                  >
                    {hideImg || imgIconShow ? (
                      <Col md={3} className="icon-verification">
                        <img src={Verified} alt="" />
                        {state?.userData?.loggedInRoleType !== "PARTNER" ? (
                          <div
                            onClick={showfirmBank}
                            style={{ cursor: "pointer" }}
                          >
                            <b style={{ color: "blue" }}>View Response</b>
                          </div>
                        ) : (
                          <></>
                        )}
                      </Col>
                    ) : state?.userData?.loggedInRoleType === "CET" ? (
                      <div>
                        <div>
                          <img className="notverified" src={notVerified} />
                        </div>

                        <div>
                          <UiButton
                            disable={disable}
                            onClick={() => handleBankTrigger()}
                            type="submit"
                            title="retrigger"
                          />
                          {disable && <Spin />}
                        </div>
                      </div>
                    ) : (
                      <img className="notverified" src={notVerified} alt="" />
                    )}

                    {hideImg}
                  </Col>
                </Row>
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    state: state && state.auth,
    engagementDetails: state?.engagementDetails?.engagementDetails,
    editPartner: state?.editPartner?.editPartner,
    EngagementMaster: state?.EngagementDetails,
    accessToken: state?.auth?.idToken,
    documents: state?.getDocuments,
    documentMaster: state?.documentsMaster,
    DocData: state?.PanDocs,
    progressData: state?.Progress?.progress,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPartnerBankDocuments: (data) => dispatch(getPartnerBankDocuments(data)),
    saveAccountNoDetails: (data) => dispatch(saveAccountNoDetails(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BankDetailsTabs);
